import React, { useEffect, useState } from "react";
import PartnerCompany from "../../../../AllPageComponents/PartnerCompany/PartnerCompany";
import FAQ from "../../../../AllPageComponents/FAQ/FAQ";
import { Link } from "react-router-dom";
import FastImage from "../../../../FastImage";
import { auto } from "@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core";
import Redirect from "../../../../AllPageComponents/Rederict";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { IoMdAddCircle } from "react-icons/io";

import { MdOutlineExpandMore } from "react-icons/md";
import Button from "@mui/material/Button";
import { Helmet } from "react-helmet-async";

const FamilyHealthInsurance = () => {
  const initialText =
    "With Beema1, get top-rated health insurance plans online. You can compare online and buy the most suitable insurance plan for you and your family. You can also get your queries answered by our team of experts.";

  const [showFullText, setShowFullText] = useState(false);

  const toggleShowFullText = () => {
    setShowFullText(!showFullText);
  };

  const [expanded, setExpanded] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const [Advadis, setAdvadis] = useState(1);

  const HandelAdvandis = (data) => {
    setAdvadis(data);
  };

  const finalizeAndDetermine = [
    {
      id: 1,
      title: "No Co-payment",
      desc: " Co-payment is the percentage of the claim that the insured individual agrees upon, to pay from his/her pocket irrespective of the amount of claim. In general, it varies from 10% to 30% and usually comes under senior citizen health insurance plans. The insurance provider only pays out the balance claim amount.",
    },
    {
      id: 2,
      title: "No Room Restrictions",
      desc: "The room rent feature in a health insurance plan suggests certain funding according to the particulars of the policy, specified only for offering coverage to fund the room rent charges during hospitalization. During the entire span of hospitalization, apart from the conventional charges needed for treatment, medicine, and surgery, there are two major angles that demand significant funding - consumables and room rent charges. Usually, most of the health insurance plans from the top-rated health insurance companies across India provide room rent features to their policyholders",
    },
    {
      id: 3,
      title: "In-patient Hospitalization Expenses",
      desc: "Covers medical costs for hospital stays exceeding 24 hours due to illness or accidental injury. When the question of hospitalization arises, the pursued expenses are beyond just the hospital bills. The preliminary medical costs and the follow-up medical costs of pre-hospitalization and post-hospitalization fetch significant charges that get accumulated on a family’s terrifying and intimidating financial burden. Availability of a health plan from the best health insurance companies along with availing an in-built pre and post-hospitalization coverage feature. Anyway, while each health insurance policy these days gets tagged with this constitutive and inherited perk, the time span for which this coverage lasts makes the actual difference. Considering the monetary benefit that this perk or dividend provides, this feature has been attached to the list of crucial factors while selecting a health insurance policy. Here's the details on the pre and post-hospitalization that would help you understand it better.",
    },
    {
      id: 4,
      title: "Pre-Hospitalization Coverage In Health Insurance",
      desc: "Before a patient gets hospitalized for a surgery or any treatment, he/she undergoes a collective of diagnostic tests that help with the looming surgery/procedure. Such procedures guarantee substantial expenses that usually burn a hole in an individual's pocket. With the best insurance policies the insurance provider covers such expenses, which is also known as pre-hospitalization costs.The best health insurance plans cover these financial disbursements for 30 to 60 days. Any which ways, the count of days for which these expenditures are funded differs from one insurance provider to another, and one health insurance plan to another.",
    },
    {
      id: 5,
      title: "Day Care Procedures",
      desc: "Includes expenses for the processes and methods of requiring less than 24-hour hospitalization. Daycare Treatment in health insurance refers to treatments/surgeries/procedures and techniques that can be covered under 24 hours of hospitalization. According to the IRDAI (Insurance Regulatory and Development Authority of India), to be classified as a daycare procedure, a treatment needs to fulfill the following conditions",
    },
    {
      id: 6,
      title: "Ambulance Charges",
      desc: "Covers expenses for ambulance services during medical emergencies.",
    },
    {
      id: 7,
      title: "Pre and Post-Hospitalization Expenses",
      desc: "Covers medical expenses before hospitalization (such as medical tests) and after discharge (follow-up consultations) for certain number of days",
    },
    {
      id: 8,
      title: "Maternity Cover",
      desc: "Typically includes expenses related to pregnancy and newborn care.",
    },
    {
      id: 9,
      title: "Organ Donor Expenses",
      desc: "Covers costs associated with organ harvesting and donor-related expenses for transplants.",
    },
  ];

  const HowToBuyHealthInsurence = [
    {
      step: 1,
      title: "Provide Your Details",
      description:
        "Enter your information to get instant access to competitive insurance quotes. Easily compare insurance policy premiums from the top-rated insurers.",
    },
    {
      step: 2,
      title: "Compare Quotes & Select The Right Health Insurance Plan",
      description:
        "Compare plans based on features and costs aligned with your needs, and your budget, and then choose the best-fit plan for yourself.",
    },
    {
      step: 3,
      title: "Pay and Get Policy Within Minutes",
      description:
        "Buy your policy online and receive it instantly in your email inbox.",
    },
    {
      step: 4,
      title: "Get Your Policy",
      description:
        "Get your policy – Once you make the payment towards your insurance policy, your policy will be issued immediately in no time, only if there are no underwriting requirements.",
    },
    {
      step: 5,
      title: "Constant Customer Support",
      description:
        "Our customer service team is dedicated to helping you with any queries.",
    },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section className="car-insurance insurance-all main-health mainnargin-insurance">
        <div className="container">
          <Redirect />
          <div className="row insurance-row-one">
            <div className="col-sm-12 col-md-4 col-lg-4 mian-one ">
              <div className="healthdiscription">
                {/* <h1>Compare & Buy the Best Family Insurance</h1> */}
                <h1>Compare & Purchase best family insurance in april 2024</h1>
                <div>
                  <span style={{ textAlign: "justify" }}>{initialText}</span>
                </div>
              </div>
              <div className="insurance-btn-set">
                <button
                  type="button"
                  className="reminderbutton"
                  data-toggle="modal"
                  data-target="#reminderpopup"
                >
                  {" "}
                  <svg
                    stroke="currentColor"
                    fill="none"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fontSize="15pt"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ color: "rgb(251, 167, 27)", margin: "0px 5px" }}
                  >
                    <circle cx={12} cy={13} r={8} />
                    <path d="M12 9v4l2 2" />
                    <path d="M5 3 2 6" />
                    <path d="m22 6-3-3" />
                    <path d="M6.38 18.7 4 21" />
                    <path d="M17.64 18.67 20 21" />
                  </svg>{" "}
                  Set Reminder
                </button>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 side-image">
              <FastImage
                url={
                  "Website%20Img/mascot_image1678942204.png?updatedAt=1718776425936"
                }
                width={auto}
                height={auto}
                alt={"arrow"}
                src={
                  "Website%20Img/mascot_image1678942204.png?updatedAt=1718776425936"
                }
              />
            </div>
            <div className="col-sm-12 col-md-4 col-lg-4 popup-main">
              <div className="form-main">
                <form id="insurance_form_get_plan">
                  <div className="d-flex align-items-center form-input">
                    <h6>
                      Compare &amp; Buy Customized Health Plans starting at just
                      <span className="specialprice">Rs ₹257/month*</span>
                    </h6>
                    <div className="blue-btn">
                      <Link to={"/healthStep1"}>
                        <button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            color: "white",
                            fontWeight: 400,
                          }}
                        >
                          Get Your Quotes
                        </button>{" "}
                        <img alt="" src="" className="" />
                      </Link>
                    </div>
                    <p className="insurance-text-light">
                      By clicking, I agree to{" "}
                      <a href="/termsandcondition">*terms &amp; conditions</a>{" "}
                      and <a href="/privacy-policy">privacy policy</a>.
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="inbulitmargine"></div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            What Is A Family Health Insurance Plan?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                Choosing family health coverage means the insurance company pays
                for your family's medical bills. You pay a yearly fee called the
                'premium,' which you can split into monthly payments. The
                coverage varies depending on the policy. The best family medical
                insurance covers medical treatments, hospital stays, ambulance
                rides, lab tests, and related costs. Some plans even give you
                money if you can't work due to illness or injury.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Benefits of Availing Health Insurance Plans for Family
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                Family floater health insurance plans offer numerous benefits to
                insured family members. For example, you can cover all family
                members, regardless of age, under one policy. Here are the key
                benefits:
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-12 d-flex justify-content-center align-items-center">
              {" "}
              <FastImage
                url="/Website%20Img/Nature%20benefits-bro.png?updatedAt=1721724499875"
                width={auto}
                height={auto}
                className="fmailimagegifs"
              />
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div>
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                >
                  <AccordionSummary
                    expandIcon={<MdOutlineExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordingback"
                  >
                    <IoMdAddCircle
                      style={{
                        color: "#2959B8",
                        marginLeft: "5px",
                        marginRight: "5px",
                      }}
                      fontSize={"15pt"}
                    />
                    <li className="listcol">
                      Hassle-Free Hospitalization Coverage:
                    </li>
                  </AccordionSummary>
                  <AccordionDetails>
                    When a family member is hospitalized, they can receive
                    cashless treatment at the insurer's network hospitals, with
                    individual health plans. This assures that all your family
                    members can access medical care support without being
                    compliant on the quality of treatment.
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange("panel2")}
                >
                  <AccordionSummary
                    expandIcon={<MdOutlineExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordingback"
                  >
                    <IoMdAddCircle
                      style={{
                        color: "#2959B8",
                        marginLeft: "5px",
                        marginRight: "5px",
                      }}
                      fontSize={"15pt"}
                    />
                    <li className="listcol">
                      Comprehensive Coverage for Parents
                    </li>
                  </AccordionSummary>
                  <AccordionDetails>
                    Many health insurance companies allow you to include both
                    your parents and parents-in-law under a family health plan
                    at no extra cost. This enables you to safeguard the health
                    of all elders in your family under a single plan.
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange("panel3")}
                >
                  <AccordionSummary
                    expandIcon={<MdOutlineExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordingback"
                  >
                    <IoMdAddCircle
                      style={{
                        color: "#2959B8",
                        marginLeft: "5px",
                        marginRight: "5px",
                      }}
                      fontSize={"15pt"}
                    />
                    <li className="listcol">Cost-Effective Premiums</li>
                  </AccordionSummary>
                  <AccordionDetails>
                    Family health insurance plans offer affordability by
                    covering your spouse, children, and parents under one
                    policy, without the need for individual premiums. However,
                    it's advisable to consider separate health cover for your
                    parents due to their age-related health concerns.
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleChange("panel4")}
                >
                  <AccordionSummary
                    expandIcon={<MdOutlineExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordingback"
                  >
                    <IoMdAddCircle
                      style={{
                        color: "#2959B8",
                        marginLeft: "5px",
                        marginRight: "5px",
                      }}
                      fontSize={"15pt"}
                    />
                    <li className="listcol">Easy Addition of New Members</li>
                  </AccordionSummary>
                  <AccordionDetails>
                    Adding a new family member to your policy is straightforward
                    with family health insurance plans. You can do this by
                    paying an additional premium without the hassle of taking
                    out a separate policy each time. Remember to increase your
                    sum insured when adding parents to an existing plan.
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel5"}
                  onChange={handleChange("panel5")}
                >
                  <AccordionSummary
                    expandIcon={<MdOutlineExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordingback"
                  >
                    <IoMdAddCircle
                      style={{
                        color: "#2959B8",
                        marginLeft: "5px",
                        marginRight: "5px",
                      }}
                      fontSize={"15pt"}
                    />
                    <li className="listcol">
                      Access To Supplementary Benefits
                    </li>
                  </AccordionSummary>
                  <AccordionDetails>
                    Family health plans often come with optional add-on benefits
                    such as critical illness coverage and maternity coverage. Be
                    assured to proactively review the policy terms to understand
                    any waiting periods associated with add-ons before choosing
                    the best health insurance plan for your family
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel6"}
                  onChange={handleChange("panel6")}
                >
                  <AccordionSummary
                    expandIcon={<MdOutlineExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordingback"
                  >
                    <IoMdAddCircle
                      style={{
                        color: "#2959B8",
                        marginLeft: "5px",
                        marginRight: "5px",
                      }}
                      fontSize={"15pt"}
                    />
                    <li className="listcol">
                      Tax Benefits On Premium Payments
                    </li>
                  </AccordionSummary>
                  <AccordionDetails>
                    Under Section 80D of the Income Tax Act, health insurance
                    premiums are eligible for tax exemption. If you're paying
                    premiums for your family's health insurance, including your
                    parents, you can avail of tax benefits
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            What Is Covered In A Family Health Insurance Plan?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                <span className="headingline">
                  In-patient Hospitalization Expenses:
                </span>{" "}
                Covers medical costs for hospital stays exceeding 24 hours due
                to illness or accidental injury.
              </p>

              <p className="textformat">
                <span className="headingline">Day Care Procedures:</span>{" "}
                Includes expenses for procedures requiring less than 24-hour
                hospitalization.
              </p>

              <p className="textformat">
                <span className="headingline">Ambulance Charges:</span> Covers
                expenses for ambulance services during medical emergencies.
              </p>
              <p className="textformat">
                <span className="headingline">
                  Pre and Post-Hospitalization Expenses:
                </span>{" "}
                Covers medical expenses before hospitalization (such as tests)
                and after discharge (like follow-up consultations) for a
                specified number of days.
              </p>

              <p className="textformat">
                <span className="headingline">Maternity Cover:</span> Typically
                includes expenses related to pregnancy and newborn care.
              </p>
              <p className="textformat">
                <span className="headingline">Organ Donor Expenses:</span>{" "}
                Covers costs associated with organ harvesting and donor-related
                expenses for transplants..
              </p>

              <p className="textformat">
                <span className="headingline">AYUSH Treatment:</span> Covers
                hospitalization expenses for treatment through alternative
                systems like Ayurveda, Homeopathy, Yoga, Siddha, and Unani.
              </p>
              <p className="textformat">
                <span className="headingline">Domiciliary Treatment:</span> Pays
                for medical expenses for home-based treatment recommended by a
                doctor.
              </p>
              <p className="textformat">
                <span className="headingline">Daily Cash Allowance:</span>{" "}
                Provides a daily allowance to cover incidental expenses during
                hospitalization.
              </p>
              <p className="textformat">
                <span className="headingline">Mental Illness Cover:</span>{" "}
                Offers coverage for mental health conditions like depression,
                anxiety, and schizophrenia, among others.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            {" "}
            Types Of Policies That Cover The Entire Family ?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                Health insurance plans for families are generally of two types -
                Family Floater Plans and Multi-Individual Plans.
              </p>
              <p className="textformat">
                1. Family Floater Plans: This option proposes a shared sum
                insured for your entire family. These plans are comparatively
                resilient and affordable than individual plans and provide
                flexibility as any family member can utilize this amount. But,
                as you know, a major claim by one individual member in the
                family can deplete the sum insured by a considerable margin,
                leaving deficient coverage for other members. Here’s where the
                Multi-Individual Policies are significantly important.
              </p>
              <p className="textformat">
                2. Multi-Individual Policies: Multi-individual plans offer
                distinguished coverage amounts for each family member under a
                single insurance policy. Hence, each person is covered under
                their own sum insured and premium. Multi-individual plans are
                more beneficial for families as it prevents the depletion or
                reduction of the total sum insured by a single major claim.
                However, multi-individual plans are expected to be more
                expensive than a family floater policy because of the separate
                sum assured approached for..
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Do You want To Opt For A Family Health Insurance Policy?
          </h1>
          <div className="yellowline"></div>
          <div className="row">
            <div className="col-md-12">
              <div className="prosconsdiv">
                <div
                  className={
                    Advadis === 1 ? "tabsproscons" : "tabsprosconsdeactive"
                  }
                  onClick={() => {
                    HandelAdvandis(1);
                  }}
                >
                  Advantages
                </div>
                <div
                  className={
                    Advadis === 2 ? "tabsproscons" : "tabsprosconsdeactive"
                  }
                  onClick={() => {
                    HandelAdvandis(2);
                  }}
                >
                  Disadvantages
                </div>
              </div>
              <div className="graybox">
                {Advadis === 1 ? (
                  <>
                    <p className="textformat">
                      <span className="specialprice">
                        1. Cost-Effective Premiums:
                      </span>{" "}
                      Family floater plans are often more cost-effective
                      compared to individual policies for each member,
                      especially when trying to buy comprehensive coverage at
                      affordable premiums.
                    </p>
                    <p className="textformat">
                      <span className="specialprice">2. Convenience:</span> A
                      single policy for the entire family simplifies tracking
                      renewals, reduces paperwork, and makes it easier to manage
                      claims and premiums.
                    </p>
                    <p className="textformat">
                      <span className="specialprice">
                        3. Comprehensive Coverage Option:
                      </span>{" "}
                      Family health insurance plans often include additional
                      benefits like maternity coverage and newborn care,
                      ensuring all healthcare needs are met.
                    </p>
                    <p className="textformat">
                      <span className="specialprice">4. Tax Benefits:</span>{" "}
                      Premiums recompensed for family health insurance policies,
                      tax deductions under Section 80D of Income Tax Act. This
                      helps you to save on taxes and secure your family's health
                      and finances, both at the same time.
                    </p>
                    <p className="textformat">
                      <span className="specialprice">
                        5. Inclusion Of Children:
                      </span>{" "}
                      Most family health insurance plans cover dependent
                      children, ensuring their healthcare needs are met without
                      the need for separate policies.
                    </p>
                  </>
                ) : Advadis === 2 ? (
                  <>
                    <p className="textformat">
                      <span className="specialprice">
                        1. Inadequate Coverage:
                      </span>{" "}
                      A major claim by one family member can exhaust the entire
                      sum insured, leaving inadequate coverage for others. This
                      can be a significant issue if multiple members need
                      medical attention within the same policy period.
                    </p>
                    <p className="textformat">
                      <span className="specialprice">2. Age Factor: </span> Two
                      Premiums for family floater plans are based on the age of
                      the eldest member, which can lead to higher costs if you
                      include older family members, making the plan less
                      affordable.
                    </p>
                    <p className="textformat">
                      <span className="specialprice">
                        3. Caps On Claim Limits:
                      </span>{" "}
                      Some plans have sub-limits on treatments, restricting the
                      amount payable for certain medical procedures, which can
                      be a drawback if higher-cost treatments are needed.
                    </p>
                    <p className="textformat">
                      <span className="specialprice">
                        4. What Is Covered In A Family Health Insurance Plan :{" "}
                      </span>{" "}
                      Let's break down the typical coverage offered by family
                      health insurance plans.
                    </p>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            How To Finalize And Determine The Best Health Insurance Plans For
            Your Family?
          </h1>
          <div className="yellowline"></div>

          <p className="textformat">
            <span>Restoration Benefits:</span> Restoration in health insurance
            is a kind of dividend or bonus that bolsters the sum insurance
            coverage by a pre-specified % age once the policyholder has raised a
            claim. Restoration benefit is an additional feature included in the
            health insurance policies that offer an additional sum insured
            amount after the primary sum insured is exhausted in a policy year.
            This feature may be convenient for policyholders likely to use their
            original sum insured because of recurring illnesses or
            hospitalisations.
          </p>

          <div className="row">
            <div className="col-md-12">
              {finalizeAndDetermine.map((data) => (
                <Accordion
                  expanded={expanded === `panel${data.id}`}
                  onChange={handleChange(`panel${data.id}`)}
                  key={data.id}
                >
                  <AccordionSummary
                    expandIcon={<MdOutlineExpandMore />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="accordingback"
                  >
                    <li className="listcol">
                      <IoMdAddCircle /> &nbsp;
                      {data.title}
                    </li>
                  </AccordionSummary>
                  <AccordionDetails className="AnwsarSpan">
                    {data.desc}
                  </AccordionDetails>
                </Accordion>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">Important Poins To Check</h1>
          <div className="yellowline"></div>
          <p className="textformat">
            <span className="headingline">Minimum Waiting Period:-</span> &nbsp;
            Waiting period in a health insurance plan is the time span for which
            a policyholder has to wait before he/she can utilize the sum
            insured. If the policyholder has to be hospitalized during the
            waiting period, the insurance plan doesn’t cover the treatment
            expenses. And if the policyowner raises a claim for these treatment
            costs, the claim is anyway rejected. But, there’s always an
            exception. With most of the policies offered by the best health
            insurance providers across India, treatments caused due to accidents
            are covered from Day 1. Types of waiting period are as follows:
          </p>
          <div className="row">
            <div className="col-md-6">
              <li className="bordercolorbox">Initial Waiting Period</li>
            </div>
            <div className="col-md-6">
              <li className="bordercolorbox1">
                Pre-existing Diseases (PED) Waiting Period
              </li>
            </div>

            <div className="col-md-6">
              <li className="bordercolorbox3">
                Waiting Periods For Critical Illnesses
              </li>
            </div>
            <div className="col-md-6">
              <li className="bordercolorbox4">
                Waiting Periods For Maternity Benefits{" "}
              </li>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <li className="bordercolorbox2">
                Waiting Periods For Specific Diseases/Procedures
              </li>
            </div>
          </div>

          <p className="textformat">
            <p className="textformat">
              <span className="headingline">Maximum No Claim Bonus:-</span>
              Imagine this – You are a healthy individual of 25 years old who
              owns a health insurance policy from a reputable health insurance
              company. Meanwhile, many years have passed, but you still haven’t
              raised a single claim as you didn’t require it so far.As a result,
              your health insurance plan is lying in a status just like your
              library membership that you haven’t used in years.
            </p>
            Unlike your library membership, not using your health insurance is
            undoubtedly a great thing, that proves that you’re as fit and fine
            plus healthy. Then what’s the utility and the beauty of not making
            any claims? This is where a No-Claim Bonus comes into play. If you
            do not file any claim in a given policy year, insurance providers
            usually provide you an extra sum insured for the following year as a
            bonus. This is known as a no-claim bonus (NCB). An NCB bounties you
            for your lifestyle maintenance and safeguarding your health and not
            making any claims during the policy year. This can primarily enhance
            your coverage amount without an increment in your premium.
            Sometimes, it can even increase your sum insured to 5 or 6 times the
            base sum insured. It is a valuable feature in your health insurance
            plan. One important note to make is that this bonus does not always
            need to increase the sum insured, it can also result in a reduced
            premium for the next policy year.
          </p>
          <p className="textformat">
            <span className="headingline">AYUSH Treatment:-</span> &nbsp; Covers
            hospitalization expenses for treatment through alternative systems
            like Ayurveda, Homeopathy, Yoga, Siddha, and Unani. AYUSH stands for
            Ayurveda, Yoga, Unani, Siddha, and Homeopathy, which are popular
            since ancient days, what we call Ancient Wisdom today. This was the
            foundation and bedrock of healthcare. These are age-old treatments
            with a history in Indian Culture since thousands of years.
          </p>

          <p className="textformat">
            <span className="headingline">Domiciliary Treatment:-</span>&nbsp;
            Pays for medical costs for home-based treatment advised by a doctor.
            Medical treatment arranged and received at home for a long-term
            illness, which otherwise would need hospitalization at a medical
            facility, is called Domiciliary Hospitalization. It covers and bears
            the medical costs incurred by a policyholder who is not capable of
            relocating to a medical facility because of medical conditions (as
            deemed by a doctor) or due to inaccessibility of hospital beds. That
            definitely does not mean all treatments received at home are
            covered. For the eligibility for domiciliary treatment, the
            following metrics and standards must be met:
          </p>
          <p className="textformat">
            A. A condition that averts you from going to the hospital or when
            you are not able to find a bed in your town.
          </p>
          <p className="textformat">
            B. The Doctor must confirm in writing that hospitalization is
            necessary.
          </p>
          <p className="textformat">
            C. All the expenses must be rational and logically approved.
          </p>

          <p className="textformat">
            <span className="headingline">Daily Cash Allowance:-</span> &nbsp;
            Provides a daily allowance to cover incidental expenses during
            hospitalization.
          </p>

          <p className="textformat">
            <p className="textformat">
              <span className="headingline">No disease-wise limits:-</span>{" "}
              &nbsp; Disease-wise capping or sub-limit in health insurance is a
              percentage of the sum insured or a fixed pre-decided amount
              allocated only for treating a particular ailment. Beyond this
              upper limit set aside for the treatment, any additional expenses
              billed will have to be paid by the policyholder. It’s always
              better to promote and advocate against disease-wise capping in
              health insurance plans, it massively impacts your savings.
            </p>

            <p className="textformat">
              Reasons why Health Insurance companies implement Disease-Wise sub
              limits: While the IRDAI (Insurance Regulatory and Development
              Authority India) has never specified a disease-wise sub-limit for
              health insurance plans, insurance providers enforce and execute
              these as an economical measure to financially safeguard themselves
              -
            </p>
          </p>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Eligibility Factors To Buy Family Health Insurance Plan What Is Not
            Covered In A Family Health Insurance Plan?
          </h1>
          <div className="yellowline"></div>
          <p className="textformat">
            When purchasing health insurance for your family, it's necessary to
            proactively evaluate the policy documents to understand the
            exclusions and waiting periods. Here are some common exclusions
            typically found in family health insurance plans:
          </p>
          <div className="row">
            <div className="col-md-12">
              <li className="liststyl2">
                Expenses For Aesthetic Treatments Or Plastic Surgeries
              </li>

              <li className="liststyl2">
                Costs related to life-support machines.
              </li>

              <li className="liststyl2">
                Treatment received overseas is generally not covered unless
                specified in the plan.
              </li>

              <li className="liststyl2">
                {" "}
                Illnesses or injuries resulting from war, nuclear reactions,
                rebellion, or acts of foreign enemies.
              </li>

              <li className="liststyl2">
                {" "}
                Injuries or illnesses due to participation in unethical or
                criminal activities are not covered.
              </li>

              <li className="liststyl2">
                {" "}
                Pregnancy or childbirth-related complications, such as voluntary
                termination, miscarriage, or abortion, may not be covered unless
                specifically mentioned in the plan.
              </li>
              <li className="liststyl2">
                Pre-existing medical conditions are usually not covered until
                the completion of the waiting period.
              </li>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h4 className="healthHeading">
            Eligibility Factors To Buy Family Health Insurance Plan
          </h4>
          <div className="yellowline"></div>
          <p className="textformat">
            Here are the qualifying factors for buying health insurance at
            Beema1
          </p>

          <div className="row">
            <div className="col-md-12">
              <div>
                <table className="familyEligibilityCriteria-table">
                  <thead>
                    <tr className="familyEligibilityCriteria-header">
                      <th className="familyEligibilityCriteria-headerCell">
                        CATEGORIES
                      </th>
                      <th className="familyEligibilityCriteria-headerCell">
                        SPECIFICATIONS
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {
                        category: "Minimum Entry Age",
                        specification: "18 years",
                      },
                      {
                        category: "Maximum Entry Age",
                        specification: "70 years",
                      },
                      {
                        category: "Family Members Covered",
                        specification:
                          "Up to 10 members (self, spouse, up to 4 dependent children, parents, and parents-in-law)",
                      },
                    ].map((item, index) => (
                      <tr key={index} className="familyEligibilityCriteria-row">
                        <td className="familyEligibilityCriteria-cell">
                          {item.category}
                        </td>
                        <td className="familyEligibilityCriteria-cell">
                          {item.specification}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <p className="textformat"></p>
                <p className="textformat">
                  {" "}
                  <span className="specialprice">
                    Flexibility to Include New Members:-
                  </span>{" "}
                  Family health plans offer the flexibility to add new members
                  to the policy by paying an additional premium.
                </p>
                <p className="textformat">
                  {" "}
                  <span className="specialprice">Policy Duration:-</span> The
                  policy ceases when the eldest family member reaches the
                  maximum covered age declared in the policy.
                </p>
                <p className="textformat">
                  {" "}
                  <span className="specialprice">
                    Adjusting Sum Assured:-
                  </span>{" "}
                  When adding new family members to the policy, it's important
                  to consider increasing the sum assured to ensure adequate
                  coverage for everyone.
                </p>
                <p className="textformat">
                  {" "}
                  <span className="specialprice">
                    Age Limit for Dependent Children:-
                  </span>{" "}
                  Once a dependent child surpasses the age limit specified in
                  the policy document, they are no longer covered under the
                  policy.
                </p>
                <p className="textformat">
                  {" "}
                  <span className="specialprice">
                    Considerations for Senior Citizen Parents:-
                  </span>{" "}
                  Avoid including senior citizen parents in your existing
                  operative family health plan, as this could noticeably
                  increase the premium. Additionally, the coverage may not be
                  suitable for addressing their age-related health issues
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            How to Buy Health Insurance Plan from Beema1{" "}
          </h1>
          <div className="yellowline"></div>
          <p className="normaltext">
            In just a few clicks, you can secure your health policy with ease
            and convenience. Our streamlined online process is designed to save
            you time and effort, allowing you to compare various plans tailored
            to your needs. Whether you're looking for comprehensive coverage or
            specific benefits, our user-friendly platform makes it simple to
            find the right health insurance for you and your family. Plus, our
            dedicated support team is here to guide you every step of the way,
            ensuring that you make informed decisions about your healthcare.
          </p>

          <div className="row">
            <div className="col-md-12 d-flex justify-content-center align-items-center hero-stepper">
              <FastImage
                url="/Website%20Img/25ppt%20(2).png?updatedAt=1727083979291"
                width={auto}
                height={auto}
                className="stepperimage"
              />
            </div>

            <div className="fixwidthDivtext">
              <div className="col-md-12 d-flex justify-content-center align-items-center">
                <div>
                  <span className="normaltext">
                    Are you ready to safeguard your health and finances against
                    unexpected medical expenses? Finding the right health
                    insurance policy can be overwhelming, but with the right
                    information, you can make an informed decision.{" "}
                  </span>

                  {HowToBuyHealthInsurence.map((data) => {
                    return (
                      <Accordion
                        expanded={expanded === `panel${data.step}`}
                        onChange={handleChange(`panel${data.step}`)}
                        key={data.step}
                      >
                        <AccordionSummary
                          expandIcon={<MdOutlineExpandMore />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                          className="accordingback"
                        >
                          <li className="listcol">
                            {data.step}.&nbsp;
                            {data.title}
                          </li>
                        </AccordionSummary>
                        <AccordionDetails className="AnwsarSpan">
                          {data.description}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Things To Consider Before Buying a Family Health Insurance Plan
          </h1>
          <div className="yellowline"></div>
          <p className="textformat">
            Before you buy a health insurance plan for your family, consider
            these important factors:
          </p>
          <div className="row">
            <div className="col-md-12">
              <p className="textformat">
                <span className="specialprice">
                  Check What The Plan Covers:
                </span>{" "}
                Look at what the plan pays for, like doctor visits or hospital
                stays. Find one that fits your family's needs and budget.
              </p>
              <p className="textformat">
                <span className="specialprice">
                  Think About Raising The Coverage:
                </span>{" "}
                Medical costs go up over time. Find a plan that lets you
                increase coverage each year. Some plans even give you more
                coverage if you don't make claims.
              </p>
              <p className="textformat">
                <span className="specialprice">
                  Check For Availability Of Cashless Hospitalization:
                </span>{" "}
                Every health insurance company in India provides cashless
                hospitalization services at hospitals in their network. This
                makes going to the hospital smoother and easier. But before you
                choose a plan, make sure to check the list of hospitals that
                offer cashless services to ensure that there are good hospitals
                near your home included in the network.
              </p>
              <p className="textformat">
                <span className="specialprice">
                  Check How Long You Can Keep The Plan:
                </span>{" "}
                Some health insurance companies in India allow you to renew
                family health policies until the oldest family member reaches 60
                or 65 years old. Look for one that you can keep for life..
              </p>
              <p className="textformat">
                <span className="specialprice">
                  Make Sure Getting Money For Medical Bills Is Easy:
                </span>{" "}
                Before you pick a plan, see how easy it is to get money back for
                medical bills. Many companies these days also offer hassle-free
                cashless hospitalization facilities.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="fixwidthDivtext">
        <div className="container">
          <h1 className="healthHeading">
            Steps to File a Claim for a Family Health Insurance Plan
          </h1>
          <div className="yellowline"></div>
          <p className="textformat">
            While filing a health insurance claim, you have two options:
            cashless claim and reimbursement claim. Here's how each process
            works
          </p>
          <div className="row">
            <div className="col-md-6">
              <table className="cashless-claim-process-table">
                <thead>
                  <tr>
                    <th className="cashless-step-header">
                      Cashless Claim Process
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="cashless-step">
                      Notify your insurance company about the health emergency.
                    </td>
                  </tr>
                  <tr>
                    <td className="cashless-step">
                      Filling the pre-authorization form available at the TPA or
                      insurance desk of the network hospital.
                    </td>
                  </tr>
                  <tr>
                    <td className="cashless-step">
                      Submit the pre-authorization form along with other
                      necessary documents to the hospital, which will forward it
                      to your insurance provider.
                    </td>
                  </tr>
                  <tr>
                    <td className="cashless-step">
                      Your insurer’s claim management team will send you an
                      approval letter once your claim request is accepted
                    </td>
                  </tr>
                  <tr>
                    <td className="cashless-step">
                      In case of any queries about your claim, the insurer will
                      communicate with the hospital to resolve and settle them
                    </td>
                  </tr>
                  <tr>
                    <td className="cashless-step">
                      If your claim is not approved, you'll need to request a
                      reimbursement claim.
                    </td>
                  </tr>
                  <tr>
                    <td className="cashless-step">
                      Once your claim is approved, receive treatment at the
                      hospital and sign all discharge documents.
                    </td>
                  </tr>
                  <tr>
                    <td className="cashless-step">
                      Your insurer shall settle down your medical bills directly
                      with the partnered hospital.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col-md-6">
              <table className="reimbursement-claim-process-table">
                <thead>
                  <tr>
                    <th className="reimbursement-step-header">
                      Reimbursement Claim Process
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="reimbursement-step">
                      Inform your insurer about your medical emergency.
                    </td>
                  </tr>
                  <tr>
                    <td className="reimbursement-step">
                      Receive treatment at a non-network hospital.
                    </td>
                  </tr>
                  <tr>
                    <td className="reimbursement-step">
                      Pay the hospital bills and collect all necessary documents
                      at the time of discharge.
                    </td>
                  </tr>
                  <tr>
                    <td className="reimbursement-step">
                      Submit the claim form completely filled in, along with
                      other essential documents to your insurer
                    </td>
                  </tr>
                  <tr>
                    <td className="reimbursement-step">
                      The claim management team of the insurer will review your
                      claim.
                    </td>
                  </tr>
                  <tr>
                    <td className="reimbursement-step">
                      You'll receive an approval or rejection letter from the
                      team after your claim has been verified.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <PartnerCompany />
      <FAQ />
    </>
  );
};

export default FamilyHealthInsurance;
